/**
 * 边的工具函数
 * 处理边的文本提取、类型判断等相关逻辑
 */

// 获取边的文本值（处理对象和字符串情况）
export const getEdgeText = (edgeData: any): string => {
  if (!edgeData) return '';

  let text = '';

  // 1. 从 text 属性获取
  if (edgeData.text) {
    if (typeof edgeData.text === 'string') {
      text = edgeData.text;
    } else if (typeof edgeData.text === 'object' && edgeData.text.value) {
      text = edgeData.text.value;
    }
  }

  // 2. 从 properties.text 获取（备用方案）
  if (!text && edgeData.properties?.text) {
    if (typeof edgeData.properties.text === 'string') {
      text = edgeData.properties.text;
    } else if (
      typeof edgeData.properties.text === 'object' &&
      edgeData.properties.text.value
    ) {
      text = edgeData.properties.text.value;
    }
  }

  return text;
};

// 检查边是否有文本内容
export const hasEdgeText = (edgeData: any): boolean => {
  const text = getEdgeText(edgeData);
  return text.length > 0;
};

// 获取边的类型
export const getEdgeType = (edgeData: any): string => {
  return edgeData?.type || 'polyline';
};

// 检查边是否为特殊类型（非默认类型）
export const isSpecialEdgeType = (edgeData: any): boolean => {
  const edgeType = getEdgeType(edgeData);
  return edgeType !== 'polyline' && edgeType !== 'line';
};

// 获取边的源节点ID
export const getEdgeSourceId = (edgeData: any): string | null => {
  return edgeData?.sourceNodeId || edgeData?.source || null;
};

// 获取边的目标节点ID
export const getEdgeTargetId = (edgeData: any): string | null => {
  return edgeData?.targetNodeId || edgeData?.target || null;
};

// 检查边是否连接到指定节点
export const isEdgeConnectedToNode = (edgeData: any, nodeId: string): boolean => {
  const sourceId = getEdgeSourceId(edgeData);
  const targetId = getEdgeTargetId(edgeData);
  return sourceId === nodeId || targetId === nodeId;
};

// 获取边的属性
export const getEdgeProperties = (edgeData: any): Record<string, any> => {
  return edgeData?.properties || {};
};

// 检查边是否有特定属性
export const hasEdgeProperty = (edgeData: any, propertyName: string): boolean => {
  const properties = getEdgeProperties(edgeData);
  return properties.hasOwnProperty(propertyName);
};

// 获取边的特定属性值
export const getEdgeProperty = (edgeData: any, propertyName: string): any => {
  const properties = getEdgeProperties(edgeData);
  return properties[propertyName];
};